// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__14q-4","modalFooterButton":"ModalNotes_modalFooterButton__oXlpS"};